import React from 'react';

import { ListPanel } from '@eika/link-panel';

import useText from '@/hooks/use-text';

interface NoCardsAvailablePanelProps {
    orderNewDebitCardUrl: string | undefined;
}

export const NoDebitCardsAvailablePanel = ({ orderNewDebitCardUrl }: NoCardsAvailablePanelProps) => {
    const {
        noBankCardsAvailableTitle,
        noBankCardsAvailableDescriptionPart1,
        noBankCardsAvailableDescriptionPart2,
        noBankCardsAvailableDescriptionPart2NoAvailableAccounts,
    } = useText();

    return (
        <ListPanel
            className="list-panel-no-cards"
            as="li"
            title={noBankCardsAvailableTitle}
            textTwo={`${noBankCardsAvailableDescriptionPart1} ${orderNewDebitCardUrl ? noBankCardsAvailableDescriptionPart2 : noBankCardsAvailableDescriptionPart2NoAvailableAccounts}`}
            url="#"
        />
    );
};
